import React, {createContext, useCallback, useContext, useEffect, useMemo, useState} from 'react'
import usePipeContext from "../../../Services/Providers/PipeProvider/usePipeContext";
import {useNavigate} from "react-router-dom";

const SolicitationContext = createContext({
    isLoading: false,
})

export const useSolicitation = () => useContext(SolicitationContext);

const SolicitationProvider = ({ children }) => {
    const [ isLoading, setLoading ] = useState( false );
    const [ url, setUrl ] = useState(null);
    const { callApiForce } = usePipeContext()
    const [ message, setMessage ] = useState( 'Buscando acesso...' );
    const Navigate = useNavigate()
    const handleInit = useCallback(() => {
        if (url === null && !isLoading) {
            setLoading(true)
            callApiForce({
                symbol: 'ADD_IN_CAMPAIGN',
                alias: null,
                payload: {
                    callback: ({ error, data: response }) => {
                        if (response && response.url && response.url.length && url === null) {
                            setUrl(response.url)
                        } else if (
                            url === null
                            && (error
                            || !response
                            || !response.url
                            || !response?.data?.url.length)
                        ) {
                            setMessage('OPS! Acesso não autorizado...')
                            setTimeout(() => {
                                Navigate('/')
                            }, 2000)
                        }
                    }
                }
            })
        }
    }, [ url,  isLoading])

    const handleComplete = useCallback(() => {
        if (url && url.length) {
            setMessage('Acesso encontrado. Migrando de catálogo...')
            setTimeout(() => {
                setMessage('Direcionamento realizado com sucesso!')
                url && window.open(url, '_blank')
            }, 3000)
        }
    }, [ url,  isLoading])

    const value = useMemo(() => {
        return {
            isLoading,
            message
        }
    }, [ isLoading, message ])

    useEffect(() => {
        if (!isLoading && url === null) {
            handleInit();
        }
        else if (url && url.length && isLoading) {
            setLoading(false);
            handleComplete()
        }
    }, [isLoading, url]);

    return (
        <SolicitationContext.Provider value={value}>
            { children }
        </SolicitationContext.Provider>
    )
}

SolicitationProvider.propTypes = {
    children: React.Children,
}

export default SolicitationProvider
